import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

function formatFieldKey(
  key: string | number | (string | number)[] | undefined,
): string {
  if (Array.isArray(key)) {
    return key.join('.');
  }
  return String(key ?? '');
}

/**
 * Wraps every Formly field with a stable `data-testid="field-<key>"`,
 * regardless of which field type or (possibly third-party) inner wrapper
 * renders it. See `testid.extension.ts` for how this gets attached to
 * every field automatically.
 */
@Component({
  selector: 'vmspdb-component-formly-wrapper-testid',
  template: `
    <div [attr.data-testid]="'field-' + formattedKey">
      <ng-container #fieldComponent></ng-container>
    </div>
  `,
  standalone: false,
})
export class FormlyWrapperTestid extends FieldWrapper {
  get formattedKey(): string {
    return formatFieldKey(this.field.key);
  }
}
